import { Directive, Input, EventEmitter, Output, ElementRef, HostListener } from '@angular/core';
import { Subscription, fromEvent } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Coord } from 'src/app/models/layout-schema-node';

@Directive({
  selector: '[layout-point]'
})
export class LayoutPointDirective {


  @Input() value: number;
  @Input() isOn: boolean;
  @Input() layoutNodeId: number

  @Output() actionLinkEmitter = new EventEmitter<{ action: "link" | "unlink" | "move", sourceId: string, targetId: string, newPoint?: Coord }>()

  private _subscription: Subscription;

  mouseStart: Position;

  mouseDelta: Position;

  offset: Position;

  constructor(
    private elementRef: ElementRef<any>) {

  }

  ngOnInit() {
    this.offset = this._getOffset();
  }

  @HostListener('mousedown', ['$event'])
  onMouseDown(start: MouseEvent) {
    this.mouseStart = { x: start.pageX, y: start.pageY };

    const mouseup$ = fromEvent(document, 'mouseup');
    this._subscription = mouseup$.subscribe((end: MouseEvent) => this.onMouseup(start, end));

    const mousemove$ = fromEvent(document, 'mousemove')
      .pipe(takeUntil(mouseup$))
      .subscribe((e: MouseEvent) => this.onMouseMove(e));

    this._subscription.add(mousemove$);
  }

  onMouseMove(event: MouseEvent) {
    this.mouseDelta = { x: (event.pageX - this.mouseStart.x), y: (event.pageY - this.mouseStart.y) };


  }

  onMouseup(start: any, end: any) {

    if (this._subscription) {
      this._subscription.unsubscribe();
      this._subscription = undefined;
    }

    if (this.mouseDelta && (Math.abs(this.mouseDelta.x) > 29 || Math.abs(this.mouseDelta.y) > 29)) {
      this.offset.x += this.mouseDelta.x;
      this.offset.y += this.mouseDelta.y;

      let pointRegExp = new RegExp('svg_[0-9]+_[0-9]+', 'g')


      if (end.target.attributes.layoutNodeId != undefined && start.target.attributes.layoutNodeId != undefined) {
        console.log("valid source and target")
        this.actionLinkEmitter.emit({ action: 'link', sourceId: start.target.attributes.layoutNodeId.value, targetId: end.target.attributes.layoutNodeId.value })
      }
      else if (start.target.attributes.layoutNodeId != undefined && end.target.attributes.id.value) {

        let pointStr: string = end.target.attributes.id.value
        let isMatch = pointRegExp.test(pointStr)

        if (isMatch) {
          console.log("POINT MATCHES", end.target.attributes)
          //check if you can move node here
          if (!end.target.attributes.layoutNodeId) {
            let splitRegExp = new RegExp('.svg_|_', 'g')

            let splitRes = pointStr.split(splitRegExp) //[1] = i, [2] = j
            this.actionLinkEmitter.emit({ action: 'move', sourceId: start.target.attributes.layoutNodeId.value, targetId: null, newPoint: {i: +splitRes[1], j: +splitRes[2]} })
          }
        }
        else {
          console.log('NON MATCH')
        }
      }

      else {
        console.log("cant do anything for you")
      }
    }

    this.mouseDelta = undefined
  }


  private _getOffset(): Position {
    const box = 0;
    return {
      x: pageXOffset,
      y: pageYOffset
    };
  }

}

export interface Position {
  x: number;
  y: number;
}
